export default "__VITE_ASSET__c63f0d5a__"